import React from 'react';

const Navigation = ({ currentUser, activeSection, onSectionChange, isMobileMenuOpen, onClose }) => {
  const isAdminUser = ['super admin', 'application admin', 'admin', 'system administrator', 'manager'].includes((currentUser?.role || '').toLowerCase());
  const isSystemAdminUser = ['super admin', 'admin', 'system administrator'].includes((currentUser?.role || '').toLowerCase());
  const isSuperAdminUser = (currentUser?.role || '').toLowerCase() === 'super admin';

  return (
    <>
      {/* Mobile Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        ></div>
      )}
      
      {/* Sidebar Navigation */}
      <nav className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-64 bg-white shadow-lg
        transform transition-transform duration-300 ease-in-out
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        flex flex-col
        overflow-hidden
      `}>
        {/* Mobile Close Button */}
        <div className="lg:hidden flex justify-between items-center p-4 border-b">
          <span className="font-bold text-jewel-red">Menu</span>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* Scrollable Menu Content */}
        <div className="flex-1 overflow-y-auto p-4 space-y-2">
          <div className="text-gray-400 text-xs font-bold uppercase mb-4 tracking-wider">Menu</div>

          <button
            onClick={() => onSectionChange('dashboard')}
            className={`w-full text-left px-4 py-2 rounded transition-colors ${
              activeSection === 'dashboard'
                ? 'bg-red-50 text-jewel-red font-bold'
                : 'hover:bg-red-50'
            }`}
          >
            <i className="fas fa-tachometer-alt mr-2"></i> Dashboard
          </button>
          
          <button 
            onClick={() => onSectionChange('advance')}
            className={`w-full text-left px-4 py-2 rounded transition-colors ${
              activeSection === 'advance' 
                ? 'bg-red-50 text-jewel-red font-bold' 
                : 'hover:bg-red-50'
            }`}
          >
            <i className="fas fa-hand-holding-usd mr-2"></i> Advance Collection
          </button>
          
          {isAdminUser && (
            <div className="space-y-2 pt-4">
              <div className="text-gray-400 text-xs font-bold uppercase mb-4 tracking-wider">Administration</div>
              <button 
                onClick={() => onSectionChange('store-master')}
                className={`w-full text-left px-4 py-2 rounded transition-colors ${
                  activeSection === 'store-master' 
                    ? 'bg-red-50 text-jewel-red font-bold' 
                    : 'hover:bg-red-50'
                }`}
              >
                <i className="fas fa-store mr-2"></i> Retail Store Master
              </button>
              <button 
                onClick={() => onSectionChange('gold-master')}
                className={`w-full text-left px-4 py-2 rounded transition-colors ${
                  activeSection === 'gold-master' 
                    ? 'bg-red-50 text-jewel-red font-bold' 
                    : 'hover:bg-red-50'
                }`}
              >
                <i className="fas fa-coins mr-2"></i> Gold Rate Master
              </button>
              {isSystemAdminUser && (
                <button
                  onClick={() => onSectionChange('user-master')}
                  className={`w-full text-left px-4 py-2 rounded transition-colors ${
                    activeSection === 'user-master'
                      ? 'bg-red-50 text-jewel-red font-bold'
                      : 'hover:bg-red-50'
                  }`}
                >
                  <i className="fas fa-users-cog mr-2"></i> User Management
                </button>
              )}
              {isSuperAdminUser && (
                <button
                  onClick={() => onSectionChange('user-store-mapping')}
                  className={`w-full text-left px-4 py-2 rounded transition-colors ${
                    activeSection === 'user-store-mapping'
                      ? 'bg-red-50 text-jewel-red font-bold'
                      : 'hover:bg-red-50'
                  }`}
                >
                  <i className="fas fa-link mr-2"></i> User Store Mapping
                </button>
              )}
            </div>
          )}

          <div className="text-gray-400 text-xs font-bold uppercase mt-6 mb-4 tracking-wider">Reporting</div>
          <button 
            onClick={() => onSectionChange('report-adv-summary')}
            className={`w-full text-left px-4 py-2 rounded transition-colors ${
              activeSection === 'report-adv-summary' 
                ? 'bg-red-50 text-jewel-red font-bold' 
                : 'hover:bg-red-50'
            }`}
          >
            <i className="fas fa-chart-bar mr-2"></i> Advance Summary
          </button>
          <button 
            onClick={() => onSectionChange('report-paymode')}
            className={`w-full text-left px-4 py-2 rounded transition-colors ${
              activeSection === 'report-paymode' 
                ? 'bg-red-50 text-jewel-red font-bold' 
                : 'hover:bg-red-50'
            }`}
          >
            <i className="fas fa-chart-pie mr-2"></i> Paymode Summary
          </button>
          <button 
            onClick={() => onSectionChange('report-date-wise')}
            className={`w-full text-left px-4 py-2 rounded transition-colors ${
              activeSection === 'report-date-wise' 
                ? 'bg-red-50 text-jewel-red font-bold' 
                : 'hover:bg-red-50'
            }`}
          >
            <i className="fas fa-calendar-alt mr-2"></i> Date-Wise Payment
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navigation;
